














import { STAMP_ICON_CONF } from '@/config';
import { useStampStore } from '@/store/stamp';
import { useTaskStore } from '@/store/task';
import { computed, defineComponent, onMounted, onUnmounted, ref, watch } from '@vue/composition-api';
import { storeToRefs } from 'pinia';
import StampItem from './stamp-item.vue';
import { StampInfo } from './types';

export default defineComponent({
  name: 'StampList',
  props: {
    isAllStamp: Boolean,
    canTouchMove: Boolean,
  },
  components: { StampItem },
  setup(props) {
    onMounted(() => {
      // 启动计时器
      startClock();
      // 初始化印花滚动
      handleTouchMove(props.canTouchMove);
    });
    onUnmounted(() => {
      // 清空计时器
      clearClock();
    });

    const preventTouchMove = (e: Event) => {
      e.preventDefault();
    };

    // 处理滑动
    const handleTouchMove = (canMove: boolean) => {
      if (canMove) {
        document.getElementById('stamplist')?.removeEventListener('touchmove', preventTouchMove);
      } else {
        document.getElementById('stamplist')?.addEventListener('touchmove', preventTouchMove, false);
      }
    };

    // 计时器相关
    const clock = ref(0); // 计时器
    const checkCleareClock = () => {
      if (clock.value) {
        clearInterval(clock.value);
        clock.value = 0;
      }
    };
    // 计时器逻辑处理
    const rowStampNum = 6; // 一行6个印花
    const currentIndex = ref(1);

    const startClock = () => {
      checkCleareClock();
      console.log('开启计时器 stamplist');
      clock.value = setInterval(() => {
        if (currentIndex.value < maxScrollRow.value) {
          handleScroll(currentIndex.value); // 滚动到下一行
          currentIndex.value += 1;
        } else {
          clearClock();
        }
      }, 2000);
    };

    const clearClock = () => {
      console.log('关闭计时器 stamplist');
      checkCleareClock();
    };

    // 用户获得的最大印花数
    const maxStampCnt = computed(() => Math.max(allTaskPrizeCount.value || 0, userTotalCount.value || 0));

    // 最大滚动行数
    const maxScrollRow = computed(() => {
      let idx = 1;
      while (idx * rowStampNum < userTotalCount.value + 1) {
        if (idx * rowStampNum >= maxStampCnt.value) return idx;
        idx += 1;
      }
      return idx;
    });

    // 处理滚动到指定行
    const handleScroll = (nextLine: number) => {
      const stampItemHeight = document.querySelector('.stamp-list-item')?.clientHeight || 0;
      document.getElementById('stamplist')?.scrollTo({
        top: nextLine * stampItemHeight,
        left: 0,
        behavior: 'smooth',
      });
    };

    // 监听收起和打开 调整计时器
    watch(
      () => props.isAllStamp,
      (newVal) => {
        if (newVal) {
          // 处理计时器
          clearClock();
          // 处理滑动
          handleTouchMove(true);
        } else {
          // 处理计时器
          // startClock();
          // 直接滚动到指定行
          handleScroll(maxScrollRow.value - 1);
          // 处理滑动
          handleTouchMove(false);
        }
      },
    );

    // 印花类列表
    const stampStore = useStampStore();
    const { userUsedCount, userTotalCount } = storeToRefs(stampStore);
    const { allTaskPrizeCount } = storeToRefs(useTaskStore());

    // 印花列表
    const stampList = computed(() => {
      const list: StampInfo[] = [];
      let stampIdx = 0;
      while (stampIdx < maxStampCnt.value) {
        if (stampIdx < userUsedCount.value) {
          list.push({
            icon: STAMP_ICON_CONF.used,
            value: stampIdx + 1,
          });
        } else if (stampIdx < userTotalCount.value) {
          list.push({
            icon: STAMP_ICON_CONF.default,
            value: stampIdx + 1,
          });
        } else {
          list.push({
            icon: STAMP_ICON_CONF.empty,
            value: stampIdx + 1,
            showValue: true,
          });
        }
        stampIdx += 1;
      }
      return list;
    });

    return {
      stampList,
      rowStampNum,
    };
  },
});
